import React from 'react';

import clsx from 'clsx';
import {StepHeader} from 'src/components/step-header';

import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';


import {
    basicPage,
    basicPageContent,
    basicPageHeader,
    basicPageTitle,
} from './basic-page.module.styl';

type Props = React.HTMLAttributes<HTMLDivElement> & {
    title: string,
    children: React.ReactNode,
    buttonsBlock: React.ReactNode,
    subtitle?: string,
    stickyHeaderId?: string,
};

export const BasicPage = ({
    children,
    title,
    subtitle,
    buttonsBlock,
    className,
    stickyHeaderId,
    ...rest
}: Props) => {
    const rootClassName = clsx(basicPage, className);

    return (
        <div className={rootClassName} {...rest}>
            <StickyElement className={basicPageHeader} id={stickyHeaderId}>
                <div className={basicPageTitle}>
                    <StepHeader title={title} subTitle={subtitle}/>
                    <Group>
                        {buttonsBlock}
                    </Group>
                </div>
            </StickyElement>
            <div className={basicPageContent}>
                {children}
            </div>
        </div>
    );
};
